var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 16,
    viewBox: "0 0 36 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_5615313397792580346452198325835208005",
    x1: "50%",
    x2: "50%",
    y1: "32.846%",
    y2: "90.794%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_8077111548583347722062864925595717067",
    x1: "50%",
    x2: "50%",
    y1: "32.846%",
    y2: "90.794%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "hinava_random_uuid_9450750376165424504467516980211977096",
    d: "M8.31 12V8.647h3.142V12h1.612V4.18h-1.612v3.167H8.31V4.18H6.698V12H8.31zm8.733.105c.485 0 .925-.091 1.322-.275.397-.183.712-.44.945-.772l-.765-.851c-.335.433-.802.65-1.402.65-.385 0-.704-.115-.956-.344-.252-.23-.403-.534-.454-.914h3.701v-.636c0-.918-.228-1.628-.686-2.13-.457-.503-1.083-.754-1.877-.754-.53 0-1.001.125-1.416.376-.414.25-.734.605-.959 1.064-.224.459-.337.98-.337 1.564v.153c0 .87.268 1.566.804 2.087.535.522 1.229.782 2.08.782zm.866-3.563h-2.162c.054-.389.177-.687.368-.894.192-.207.442-.311.751-.311.328 0 .583.094.763.282.18.188.273.454.28.799v.124zm4.151 3.563c.6 0 1.087-.209 1.463-.626.032.207.085.38.158.521h1.569v-.09c-.15-.285-.228-.702-.234-1.254V8.14c0-.653-.21-1.16-.63-1.52-.419-.36-.987-.54-1.704-.54-.472 0-.898.081-1.277.245-.38.165-.674.39-.883.675-.208.285-.313.597-.313.935h1.554c0-.22.075-.392.223-.517.148-.124.353-.186.614-.186.297 0 .515.08.653.241.139.161.208.376.208.644v.334h-.717c-.861.003-1.52.17-1.978.498-.457.328-.686.802-.686 1.42 0 .5.187.915.562 1.244.375.328.847.492 1.418.492zm.335-1.186c-.236 0-.422-.062-.557-.186-.136-.125-.204-.284-.204-.479l.005-.09c.051-.54.464-.809 1.239-.809h.583v1c-.092.172-.236.31-.43.411-.195.102-.407.153-.636.153zm5.787 1.186c.322 0 .634-.046.937-.138V10.79c-.13.026-.282.038-.454.038-.233 0-.39-.046-.474-.138-.083-.093-.124-.248-.124-.464V7.327h.995V6.19h-.995V4.76h-1.55v1.43h-.85v1.138h.85v3.133c.02 1.097.574 1.645 1.665 1.645z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#454545",
    xlinkHref: "#hinava_random_uuid_9450750376165424504467516980211977096"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#hinava_random_uuid_5615313397792580346452198325835208005)",
    xlinkHref: "#hinava_random_uuid_9450750376165424504467516980211977096"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hinava_random_uuid_8077111548583347722062864925595717067)",
    d: "M33.5 0C34.88 0 36 1.12 36 2.5v11c0 1.38-1.12 2.5-2.5 2.5h-31C1.12 16 0 14.88 0 13.5v-11C0 1.12 1.12 0 2.5 0h31zm0 1h-31c-.78 0-1.42.595-1.493 1.356L1 2.5v11c0 .78.595 1.42 1.356 1.493L2.5 15h31c.78 0 1.42-.595 1.493-1.356L35 13.5v-11c0-.78-.595-1.42-1.356-1.493L33.5 1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeat);
export default __webpack_public_path__ + "static/media/heat.58195bfa83007171d9d0893453c03438.svg";
export { ForwardRef as ReactComponent };